import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

const API_URL = process.env.REACT_APP_API_URL;

class SignalRBase {
	constructor(props) {
		let usr = localStorage.getItem("user");
		if (!usr) {
			return;
		}
		const user = JSON.parse(usr);
		this.connection = new HubConnectionBuilder()
			.configureLogging(LogLevel.Error)
			.withUrl(`${API_URL}/risehub`, {
				accessTokenFactory: () => user.access_token,
			})
			.build();

		this.start();
	}

	start = () => {
		this.connection.start().catch((error) => { });
	};

	stop = () => {
		this.connection.stop();
	}
}

const signalRBase = new SignalRBase()
export { signalRBase as SignalRBase }